import { Link } from "react-router-dom";
import { Menu } from "lucide-react";
import { useState } from "react";
import kopfaiLogo from "@/assets/kopfai-blog-logo.svg";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

const navigation = [
  { name: "Início", href: "/" },
  { name: "Sobre", href: "/sobre" },
  { name: "Conhecer a KopfAI", href: "https://kopfai.com/ref/P4N9NKTN", isButton: true, external: true },
];

export function BlogHeader() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <nav className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8">
        <div className="flex lg:flex-1">
          <Link to="/" className="-m-1.5 p-1.5">
            <span className="sr-only">KopfAI Blog</span>
            <img className="h-6 md:h-8 w-auto" src={kopfaiLogo} alt="KopfAI" />
          </Link>
        </div>

        <div className="flex lg:hidden">
          <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon">
                <Menu className="h-6 w-6" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[300px]">
              <div className="flex flex-col gap-6 mt-8">
                {navigation.map((item) =>
                  item.isButton ? (
                    item.external ? (
                      <Button
                        key={item.name}
                        asChild
                        onClick={() => setMobileMenuOpen(false)}
                        className="w-full bg-gradient-to-br from-kopf-primary from-20% to-kopf-accent hover:from-kopf-primary/90 hover:from-20% hover:to-kopf-accent/90 text-white font-semibold"
                      >
                        <a href={item.href} target="_blank" rel="noopener noreferrer">
                          {item.name}
                        </a>
                      </Button>
                    ) : (
                      <Link key={item.name} to={item.href}>
                        <Button
                          onClick={() => setMobileMenuOpen(false)}
                          className="w-full bg-gradient-to-br from-kopf-primary from-20% to-kopf-accent hover:from-kopf-primary/90 hover:from-20% hover:to-kopf-accent/90 text-white font-semibold"
                        >
                          {item.name}
                        </Button>
                      </Link>
                    )
                  ) : (
                    <Link
                      key={item.name}
                      to={item.href}
                      onClick={() => setMobileMenuOpen(false)}
                      className="text-lg text-kopf-text hover:text-kopf-primary transition-colors font-medium"
                    >
                      {item.name}
                    </Link>
                  ),
                )}
              </div>
            </SheetContent>
          </Sheet>
        </div>

        <div className="hidden lg:flex lg:gap-x-8 lg:items-center">
          {/* Desktop Navigation */}
          {navigation.map((item) =>
            item.isButton ? (
              item.external ? (
                <Button
                  key={item.name}
                  asChild
                  className="bg-gradient-to-br from-kopf-primary from-20% to-kopf-accent hover:from-kopf-primary/90 hover:from-20% hover:to-kopf-accent/90 text-white font-semibold"
                >
                  <a href={item.href} target="_blank" rel="noopener noreferrer">
                    {item.name}
                  </a>
                </Button>
              ) : (
                <Link key={item.name} to={item.href}>
                  <Button className="bg-gradient-to-r from-blue-500 to-yellow-400 hover:from-blue-600 hover:to-yellow-500 text-white font-semibold">
                    {item.name}
                  </Button>
                </Link>
              )
            ) : (
              <Link
                key={item.name}
                to={item.href}
                className="text-kopf-text hover:text-kopf-primary transition-colors font-medium"
              >
                {item.name}
              </Link>
            ),
          )}
        </div>
      </nav>
    </header>
  );
}
